"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTDataSource = void 0;
var RESTDataSource_1 = require("./RESTDataSource");
Object.defineProperty(exports, "RESTDataSource", { enumerable: true, get: function () { return RESTDataSource_1.RESTDataSource; } });
//# sourceMappingURL=index.js.map